import REQUIRED_PERMISSIONS from './requiredPermissions';
import { credentials } from '@shootsta/client-auth';
import getAlias from '@shootsta/get-alias';
// Imported inline to avoid pulling in the full @core/shared barrel export,
// which causes test failures due to transitive COLOURS dependency.
const openHubSpotWidget = () => {
  if (window.HubSpotConversations?.widget) {
    window.HubSpotConversations.widget.load();
    window.HubSpotConversations.widget.open();
  }
};

import config from '../../config';

const {
  USER_HOMEPAGE,
  SCRIPTS,
  STORYBOARDS,
  DAM,
  ORGANISATION,
  VIDEO_TOOL,
  CAST,
  CLIENT_STATISTICS_REPORTS
} = REQUIRED_PERMISSIONS;

const onClickCue = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const publicScriptId = searchParams.get('publicScriptId');

  const { token } = credentials.get() || {};

  if (!token) {
    const newUrl = window.location.href.split('?')[0];
    window.history.replaceState({}, document.title, newUrl);
    return;
  }

  const alias = getAlias();

  const { cueAppEndpoint } = config;

  const returnTo = new URL(`${cueAppEndpoint}/app`);

  if (publicScriptId) {
    returnTo.searchParams.set('publicScriptId', publicScriptId);
  }

  return window.open(
    `${cueAppEndpoint}/?t=${token}&alias=${alias}&returnto=${returnTo.toString()}`,
    '_blank'
  );
};

export const topNavLinks = [
  config.HIDE_FEATURES.userHomepage
    ? null
    : {
        label: 'Home',
        url: '/home',
        icon: 'home',
        requiredPermission: USER_HOMEPAGE
      },
  {
    label: 'Pro',
    url: '/pro',
    icon: 'prodef',
    requiredPermission: VIDEO_TOOL,
    // Children render as an inline expandable group on desktop and as a
    // drill-in submenu on mobile (both read `subMenuRoutes`).
    subMenuRoutes: [
      {
        label: 'Active',
        url: '/pro/active',
        icon: 'dot',
        iconSize: 10,
        requiredPermission: VIDEO_TOOL
      },
      {
        label: 'Completed',
        url: '/pro/completed',
        icon: 'dot',
        iconSize: 10,
        requiredPermission: VIDEO_TOOL
      }
    ]
  },
  config.HIDE_FEATURES.hideStoryboardInClientNav
    ? null
    : {
        label: 'Storyboards',
        url: '/storyboards',
        icon: 'storyboard',
        requiredPermission: STORYBOARDS
      },
  {
    label: 'Cast',
    url: '/cast',
    icon: 'castdef',
    requiredPermission: CAST
  },
  /**
   * TODO: To include orgPackage and org permission
   * check for elevate at a later scope
   */
  {
    label: 'Elevate',
    url: '/elevate',
    icon: 'elevatedef',
    orgPackageRequired: false,
    requiredPermission: ''
  },
  {
    label: 'Cue',
    url: '/scripts',
    icon: 'cuedef',
    requiredPermission: SCRIPTS
  },
  {
    label: 'Cue',
    url: '/cue',
    icon: 'cuedef',
    requiredPermission: SCRIPTS,
    onClick: onClickCue
  },
  {
    label: 'Media Library',
    url: '/medialibrary',
    icon: 'medialibrary',
    requiredPermission: DAM
  },
  {
    label: 'Reports',
    url: '/reports',
    icon: 'financereports',
    requiredPermission: CLIENT_STATISTICS_REPORTS
  }
] as const;

export const bottomNavLinks = [
  {
    label: 'Academy',
    onClick: () => window.open('https://academy.shootsta.com', '_blank'),
    icon: 'learning'
  },
  config.HIDE_FEATURES.bookings
    ? null
    : {
        label: 'Bookings',
        url: '/bookings',
        icon: 'bookingsdef',
        orgPackageRequired: true,
        onClick: () => window.open('/bookings', '_blank')
      },
  {
    label: 'Organisation',
    url: '/organisation',
    icon: 'company',
    requiredPermission: ORGANISATION
  },
  {
    label: 'Help Center',
    onClick: () => window.open('https://help.shootsta.com/en', '_blank'),
    icon: 'faq'
  },
  {
    label: 'Live Chat',
    onClick: openHubSpotWidget,
    icon: 'hubspot'
  }
] as const;

export const adminBottomNavLinks = [
  {
    label: 'Help',
    onClick: () => window.open('https://help.shootsta.com/en', '_blank'),
    icon: 'faq'
  },
  {
    label: 'Live Chat',
    onClick: openHubSpotWidget,
    icon: 'hubspot'
  }
] as const;
